import { Card, Input } from '@ui/themed';
import { t } from 'i18next';
import { withFieldGroup } from '../../../lib/app-form';
import { fieldErrorMessage } from '../../../utils/form';
import type { SectionContextValues } from '../section-context-schema';

/** i18n key prefix for a form's `.details` sub-tree (company or section). */
export type SectionDetailsPrefix =
  | 'features:companies.pages.company_form_page.details'
  | 'features:sections.pages.section_form_page.details';

/** The shared "details" fields (a subset of the section context) this group binds. */
const SECTION_DETAILS_DEFAULTS: Pick<
  SectionContextValues,
  'name' | 'external_id' | 'integration_id' | 'accounting_id'
> = { name: '', external_id: '', integration_id: '', accounting_id: '' };

/**
 * The "details" card shared by the company and section forms (name, accounting
 * id, external id, integration id). The two forms use parallel but differently
 * worded translation keys, so the `.details.*` key prefix is passed in.
 */
export const IdentifierFieldsCard = withFieldGroup({
  defaultValues: SECTION_DETAILS_DEFAULTS,
  props: {} as { translationPrefix: SectionDetailsPrefix },
  render: function IdentifierFieldsCardRender({ group, translationPrefix }) {
    return (
      <Card>
        <Card.Header headingLevel="h2">{t(`${translationPrefix}.title`)}</Card.Header>
        <Card.Body>
          <div className="grid w-full gap-3 sm:grid-cols-2">
            <group.Field name="name">
              {(field) => (
                <Input
                  label={t(`${translationPrefix}.name_label`)}
                  placeholder={t(`${translationPrefix}.name_placeholder`)}
                  value={field.state.value}
                  onChange={field.handleChange}
                  error={fieldErrorMessage(field.state.meta.errors)}
                />
              )}
            </group.Field>
            <group.Field name="accounting_id">
              {(field) => (
                <Input
                  label={t(`${translationPrefix}.accounting_id_label`)}
                  placeholder={t(`${translationPrefix}.accounting_id_placeholder`)}
                  value={field.state.value}
                  onChange={field.handleChange}
                  error={fieldErrorMessage(field.state.meta.errors)}
                />
              )}
            </group.Field>
            <group.Field name="external_id">
              {(field) => (
                <Input
                  label={t(`${translationPrefix}.external_id_label`)}
                  placeholder={t(`${translationPrefix}.external_id_placeholder`)}
                  value={field.state.value}
                  onChange={field.handleChange}
                  error={fieldErrorMessage(field.state.meta.errors)}
                />
              )}
            </group.Field>
            <group.Field name="integration_id">
              {(field) => (
                <Input
                  label={t(`${translationPrefix}.integration_id_label`)}
                  placeholder={t(`${translationPrefix}.integration_id_placeholder`)}
                  value={field.state.value}
                  onChange={field.handleChange}
                  error={fieldErrorMessage(field.state.meta.errors)}
                />
              )}
            </group.Field>
          </div>
        </Card.Body>
      </Card>
    );
  },
});
